/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef, createContext} from 'react';
import classNames from 'classnames';
import css from '../../../styles/FacebookStatistics.module.scss';
import {useStore} from '../../../store/store';
import {observer} from 'mobx-react';
import {useNavigate, useLocation} from 'react-router-dom';
import {objectToQueryString, queryParamsToObject} from './functionsFotTable';
import {useFullWidth} from '../../hooks/useFullWidth';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import {
  createDBForPage,
  addFlattenedItemsToGroup,
  resetItemsTable,
  getHierarchicalFlatListSorted,
  getHierarchicalFlatListSortedGlobal,
  deleteDatabase,
  updateItemByIdAndGroup,
  updateItemByGroup,
  deleteChildrenTreeByIdAndGroup,
  deleteTreeByGroup,
  getAncestorsByCompositeId,
  sortGroupInDB,
} from './dexie/db';
import Table from './Table';

export const TableWrapperContext = createContext(null);

const TableWrapper = ({
  children,
  isVerify,
  timeConfig,
  getMethod,
  setPreloader,
  setPrevTimeConfig,
  prevTimeConfig,
  getFilters,
  defaultGroups = [],
  hasHiddenGroups = false,
  defaultFilters = [],
  setEditItemId,
  edit,
  CalendarForFullScreen,
  baseFields,
  disabledByDefault = [],
  branch = 'fb',
  idForChangeSize = null,
  isFullWidth = true,
}) => {
  useFullWidth(isFullWidth);
  const theme = useResolvedThemeMode();
  const location = useLocation();
  const store = useStore();
  const db = useRef();
  const pageName = useRef();
  const abortControllerRef = useRef(null);

  const [fullMode, setFullMode] = useState(false);
  const [resultsCount, setResultsCount] = useState(0);
  const [timeInfo, setTimeInfo] = useState(null);
  const updatedTime = useRef(null);
  const timerForTimeInfo = useRef(null);

  // Групи при зміні сторінки, також включають базові групи
  const activeGroupsRef = useRef([]);
  const activeFiltersRef = useRef([]);

  // Групи, які використовують фільтри при першому завантаженні сторінки
  const activeGroupsForFiltersRef = useRef([]);
  const activeFiltersForFiltersRef = useRef({});

  // Всі отримані фільтри
  const [filterData, setFilterData] = useState({});

  // Поле, за яким відбулось сортування
  const [fieldToSortBy, setFieldToSortBy] = useState(null);

  // Групи, за якими відбулось сортування
  const [groupsToSortBy, setGroupsToSortBy] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [foundItems, setFoundItems] = useState(null);
  const [columnsSettings, setColumnsSettings] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [currentOpening, setCurrentOpening] = useState(null);

  const [presets, setPresets] = useState([]);
  const [presetData, setPresetData] = useState({});
  const [activePreset, setActivePreset] = useState(null);

  //функція для заміни :id на children для pathname
  const replaceTrailingNumberWithChildren = (pathname) => {
    // регекс: шукаємо "/" та одну чи більше цифр у кінці рядка
    const regex = /\/\d+$/;
    if (regex.test(pathname)) {
      return pathname.replace(regex, '/children');
    }
    return pathname;
  };

  // Видалення бази даних при закритті або перезавантаженні сторінки
  useEffect(() => {
    const handleBeforeUnload = async (event) => {
      await deleteDatabase(db.current);
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      clearTimeout(timerForTimeInfo.current);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      deleteDatabase(db.current);
    };
  }, []);

  useEffect(() => {
    if (foundItems !== null) {
      setResultsCount(foundItems.length);
    } else {
      setResultsCount(tableData.length);
    }
  }, [foundItems]);

  // Слідкування за змінами timeConfig для оновлення даних
  useEffect(() => {
    if (
      Object.keys(presetData).length > 0 &&
      (presetData?.time_config !== timeConfig.time_config ||
        presetData?.time_start !== timeConfig.time_start ||
        presetData?.time_end !== timeConfig.time_end)
    ) {
      getFirstData(
        {
          ...timeConfig,
          ...activeFiltersRef.current,
          group: activeGroupsRef.current.length > 0 ? activeGroupsRef.current[0] : '',
        },
        null,
        null,
        groupsToSortBy.length > 0 ? groupsToSortBy[0] : fieldToSortBy
      );

      resetPreset({
        ...timeConfig,
        ...activeFiltersRef.current,
        group: activeGroupsRef.current,
        sort:
          groupsToSortBy.length > 0
            ? [groupsToSortBy[0].sortOrder, groupsToSortBy[0].sortField, groupsToSortBy[0].group]
            : !!fieldToSortBy
            ? [fieldToSortBy.sortOrder, fieldToSortBy.sortField]
            : '',
        columns: presetData.columns || [],
      });
    }
  }, [timeConfig]);

  const resetPreset = (data) => {
    setPresetData(data);
    localStorage.setItem(
      `localPreset_${replaceTrailingNumberWithChildren(location?.pathname)}`,
      objectToQueryString(data)
    );
    localStorage.setItem(`preset_${replaceTrailingNumberWithChildren(location?.pathname)}`, null);
    setActivePreset(null);
  };

  // Виконується при першому завантаженні сторінки та встановлює всі налаштування

  // useEffect(() => {
  //   if (!isVerify || !timeConfig || prevTimeConfig !== null) return;

  //   (async () => {
  //     const presetsFromStore = await store.requestGet('statistics/presets', {
  // params: {table_id: `preset_${replaceTrailingNumberWithChildren(location?.pathname)}`},
  // });
  //     setPresets(presetsFromStore);

  //     const urlPreset = location.search.length > 0 ? location.search : '';
  //     const savedPreset = objectToQueryString(
  //       JSON.parse(localStorage.getItem(`preset_${replaceTrailingNumberWithChildren(location?.pathname)}`)) || {}
  //     );
  //     const localPreset = localStorage.getItem(`localPreset_${replaceTrailingNumberWithChildren(location?.pathname)}`);
  //     let time_config = '';
  //     let time_start = '';
  //     let time_end = '';

  //     if (urlPreset?.includes('time_config')) {
  //       const obj = queryParamsToObject(urlPreset);
  //       time_config = obj.time_config;
  //       time_start = obj.time_start;
  //       time_end = obj.time_end;
  //     } else if (savedPreset?.includes('time_config')) {
  //       const obj = queryParamsToObject(savedPreset);
  //       time_config = obj.time_config;
  //       time_start = obj.time_start;
  //       time_end = obj.time_end;
  //     } else if (localPreset?.includes('time_config')) {
  //       const obj = queryParamsToObject(localPreset);
  //       time_config = obj.time_config;
  //       time_start = obj.time_start;
  //       time_end = obj.time_end;
  //     } else {
  //       time_config = '';
  //       time_start = '';
  //       time_end = '';
  //     }

  //     if (!time_config) {
  //       setPrevTimeConfig(timeConfig);
  //     } else {
  //       setPrevTimeConfig({
  //         time_config,
  //         time_start: time_start ? Number(time_start) * 1000 : '',
  //         time_end: time_end ? Number(time_end) * 1000 : '',
  //       });
  //     }
  //   })();
  // }, [isVerify, timeConfig]);

  useEffect(() => {
    const parsedColumns = JSON.parse(
      localStorage.getItem(`columns_${replaceTrailingNumberWithChildren(location?.pathname)}`) ||
        'null'
    );

    setColumnsSettings(parsedColumns?.length > 0 ? true : disabledByDefault);

    if (!isVerify || !timeConfig || prevTimeConfig !== null) return;

    (async () => {
      setPreloader(true);
      createDB();

      setFilterData(await getFilters(store));

      const presetsFromStore = await store.requestGet('statistics/presets', {
        params: {table_id: `preset_${replaceTrailingNumberWithChildren(location?.pathname)}`},
      });
      setPresets(presetsFromStore);

      // Перевірка наявності url-параметрів
      if (location.search.length > 0) {
        activatePreset(location.search);
        setPreloader(false);
        return;
      }

      //Перевірка наявності пресета
      const savedPreset = JSON.parse(
        localStorage.getItem(`preset_${replaceTrailingNumberWithChildren(location?.pathname)}`)
      );

      if (savedPreset !== null) {
        activatePreset(savedPreset.url);
        setActivePreset(savedPreset?.id);
        setPreloader(false);
        return;
      }

      //Перевірка наявності конфігурації із попередньої сесії
      const localPreset = localStorage.getItem(
        `localPreset_${replaceTrailingNumberWithChildren(location?.pathname)}`
      );
      if (localPreset) {
        try {
          activatePreset(localPreset);
          setPreloader(false);
          return;
        } catch (e) {
          console.error('Помилка парсингу localPreset:', e);
        }
      }

      //Якщо нічого немає
      setPrevTimeConfig(timeConfig);

      const baseParams = {
        ...timeConfig,
        group: defaultGroups.length > 0 ? defaultGroups : [],
        columns: disabledByDefault || [],
      };

      activatePreset(objectToQueryString(baseParams), true);
      setPreloader(false);
    })();
  }, [isVerify, timeConfig, prevTimeConfig]);

  const updateTime = () => {
    clearTimeout(timerForTimeInfo.current);
    updatedTime.current = new Date().getTime();
    setTimeInfo(updatedTime.current - new Date().getTime());
    timerForTimeInfo.current = setInterval(() => {
      setTimeInfo(new Date().getTime() - updatedTime.current);
    }, 10000);
  };

  /**
   * Активує пресет за параметрами у вигляді string
   */
  const activatePreset = (preset, isBlankPage = false) => {
    let queryObj = queryParamsToObject(preset);

    if ('sort' in queryObj && queryObj.sort.length > 2) {
      queryObj.sort = [];
    }

    let newTimeConfig = null;

    if (queryObj?.time_config) {
      newTimeConfig = {
        time_config: queryObj.time_config,
        time_start: queryObj.time_start,
        time_end: queryObj.time_end,
      };
      setPrevTimeConfig({
        time_config: queryObj.time_config,
        time_start: queryObj.time_start ? Number(queryObj.time_start) * 1000 : '',
        time_end: queryObj.time_end ? Number(queryObj.time_end) * 1000 : '',
      });
    } else {
      newTimeConfig = structuredClone(timeConfig);
    }

    //для фільтрів за замовчуванням
    if (isBlankPage) {
      //тільки якщо сторінка пуста ми застосовуємо всі фільтри за замовчуванням
      const filters = defaultFilters.reduce((acc, item) => {
        acc[item.filter] = item.options;
        return acc;
      }, {});
      queryObj = {...queryObj, ...filters};
    } else {
      const filters = defaultFilters
        .filter((item) => item.isFixed)
        .reduce((acc, item) => {
          acc[item.filter] = item.options;
          return acc;
        }, {});
      queryObj = {...filters, ...queryObj};
    }

    //для груп за замовчуванням
    let newGroups = queryObj.group
      ? typeof queryObj.group === 'string'
        ? [queryObj.group]
        : queryObj.group.slice()
      : [];

    if (hasHiddenGroups) {
      newGroups = defaultGroups.map((item) => item.group) || [];
    } else {
      if (isBlankPage) {
        newGroups = defaultGroups.map((item) => item.group) || [];
      } else {
        // Отримуємо масив груп, які повинні бути фіксованими
        const fixedGroups = defaultGroups.filter((item) => item.isFixed).map((item) => item.group);
        if (fixedGroups.length > 0) {
          fixedGroups.forEach((group, index) => {
            const currentIndex = newGroups.indexOf(group);

            if (currentIndex !== -1) {
              // Якщо група знайдена, але її індекс не відповідає потрібному,
              // видаляємо її з поточної позиції та вставляємо на позицію index
              if (currentIndex !== index) {
                newGroups.splice(currentIndex, 1);
                newGroups.splice(index, 0, group);
              }
            } else {
              // Якщо група відсутня, вставляємо її на позицію index (тобто у початок)
              newGroups.splice(index, 0, group);
            }

            // Видаляємо всі дублікати цієї групи, що можуть з’явитись після встановленої позиції
            newGroups = newGroups.filter((item, idx) => {
              return item !== group || idx === newGroups.indexOf(group);
            });
          });
        }
      }
    }

    const sort = queryObj.sort;
    const columns = !!queryObj.columns ? queryObj.columns : [];

    activeGroupsRef.current = newGroups;
    activeGroupsForFiltersRef.current = newGroups;

    delete queryObj.time_config;
    delete queryObj.time_start;
    delete queryObj.time_end;
    delete queryObj.group;
    delete queryObj.sort;
    delete queryObj.columns;

    activeFiltersForFiltersRef.current = queryObj;
    activeFiltersRef.current = queryObj;

    setPresetData({
      ...newTimeConfig,
      ...queryObj,
      group: activeGroupsRef.current,
      sort,
      columns,
    });

    getFirstData(
      {
        ...newTimeConfig,
        ...queryObj,
        group: activeGroupsRef.current.length > 0 ? activeGroupsRef.current[0] : '',
      },
      null,
      null,
      !!sort
        ? sort.length > 2
          ? {sortOrder: sort[0], sortField: sort[1], group: sort[2]}
          : {sortOrder: sort[0], sortField: sort[1]}
        : null
    );
    if (!!sort) {
      if (sort.length > 2) {
        setGroupsToSortBy([{sortOrder: sort[0], sortField: sort[1], group: sort[2]}]);
        setFieldToSortBy(null);
      } else {
        setFieldToSortBy({sortOrder: sort[0], sortField: sort[1]});
        setGroupsToSortBy([]);
      }
    } else {
      setGroupsToSortBy([]);
      setFieldToSortBy(null);
    }
  };

  /**
   * Створює базу даних для поточної сторінки
   */
  const createDB = async () => {
    // Створюємо версію таблиці, щоб уникнути конфлікту між сторінками
    const linksDb = JSON.parse(localStorage.getItem('linksDb')) || {};
    linksDb[`${replaceTrailingNumberWithChildren(location?.pathname)}`] =
      linksDb[`${replaceTrailingNumberWithChildren(location?.pathname)}`] + 1 || 0;
    localStorage.setItem('linksDb', JSON.stringify(linksDb));
    pageName.current = `${replaceTrailingNumberWithChildren(location?.pathname)}/${
      linksDb[`${replaceTrailingNumberWithChildren(location?.pathname)}`]
    }`;

    const currentDB = createDBForPage(pageName.current);
    db.current = currentDB;

    await resetItemsTable(currentDB);
  };

  /**
   * Отримує початкові дані для таблиці
   */
  const getFirstData = async (obj, parentId, group = null, sort) => {
    setLoadingData(true);
    await resetItemsTable(db.current);
    // Якщо існує попередній запит – його скасовуємо
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    const req = await store.requestGet(getMethod, {
      params: objectToQueryString(obj),
      signal: controller.signal,
      preloader: false,
    });

    !parentId && setResultsCount(req?.rows.length);

    const addList = await addFlattenedItemsToGroup(
      db.current,
      req?.rows,
      req && 'filter' in req && 'group' in req?.filter ? req.filter.group[0] : null,
      parentId,
      !group ? activeGroupsRef.current : group,
      !sort ? {sortField: 'id', sortOrder: 'desc'} : sort
    );
    if (!addList) return;
    // Отримуємо дані згідно з customOrder (початковий порядок встановлюється при flatten)

    let res;
    if (sort) {
      res = await getHierarchicalFlatListSortedGlobal(db.current, sort?.sortField, sort?.sortOrder);
    } else {
      res = await getHierarchicalFlatListSorted(db.current);
    }

    if (abortControllerRef.current === controller) {
      abortControllerRef.current = null;
    }
    setTableData(res);
    updateTime();
    setLoadingData(false);
  };

  /**
   * Змінює фільтри списку
   */
  const changeListFilters = async (filters, emptyOptions = false) => {
    activeFiltersRef.current = filters;
    resetPreset({
      ...timeConfig,
      ...filters,
      group: activeGroupsRef.current,
      sort:
        groupsToSortBy.length > 0
          ? [groupsToSortBy[0].sortOrder, groupsToSortBy[0].sortField, groupsToSortBy[0].group]
          : !!fieldToSortBy
          ? [fieldToSortBy.sortOrder, fieldToSortBy.sortField]
          : '',
      columns: presetData?.columns || [],
    });

    //якщо emptyOptions = true, використовуєм коли нам потрібно додати фільтр і зберегти його (але він не має опцій)
    if (emptyOptions) return;

    await getFirstData(
      {
        ...timeConfig,
        ...filters,
        group: activeGroupsRef.current.length > 0 ? activeGroupsRef.current[0] : '',
      },
      null,
      activeGroupsRef.current,
      groupsToSortBy.length > 0 ? groupsToSortBy[0] : fieldToSortBy
    );
  };

  /**
   * Змінює групи списку
   */
  const changeListGroups = async (group, filters) => {
    // 1: Якщо група порожня – скидаємо таблицю
    if (group.length === 0) {
      activeGroupsRef.current = [];

      resetPreset({
        ...timeConfig,
        ...filters,
        group: [],
        columns: presetData?.columns || [],
      });

      await getFirstData(
        {...timeConfig, ...filters},
        null,
        null,
        groupsToSortBy.length > 0 ? groupsToSortBy[0] : fieldToSortBy
      );
      return;
    }

    // 2: Якщо перша група змінилась
    if (activeGroupsRef.current.length === 0 || group[0].value !== activeGroupsRef.current[0]) {
      activeGroupsRef.current = group.map((item) => item.value);

      resetPreset({
        ...timeConfig,
        ...filters,
        group: activeGroupsRef.current,
        sort: !fieldToSortBy
          ? ['desc', 'id', group[0].value]
          : [fieldToSortBy.sortOrder, fieldToSortBy.sortField],
        columns: presetData?.columns || [],
      });

      await getFirstData(
        {...timeConfig, ...filters, group: group[0].value},
        null,
        null,
        !fieldToSortBy
          ? {
              sortOrder: 'desc',
              sortField: 'id',
            }
          : fieldToSortBy
      );
      !fieldToSortBy &&
        setGroupsToSortBy([
          {
            sortOrder: 'desc',
            sortField: 'id',
            group: group[0].value,
          },
        ]);
      return;
    }

    // 3: Кількість груп збільшилась на +1
    if (group.length - 1 === activeGroupsRef.current.length) {
      await updateItemByGroup(
        db.current,
        activeGroupsRef.current[activeGroupsRef.current.length - 1],
        {isExpandable: true}
      );
      const res = await getHierarchicalFlatListSorted(db.current);
      setTableData(res);
      activeGroupsRef.current = group.map((item) => item.value);
      resetPreset({
        ...timeConfig,
        ...filters,
        group: activeGroupsRef.current,
        sort:
          groupsToSortBy.length > 0
            ? [groupsToSortBy[0].sortOrder, groupsToSortBy[0].sortField, groupsToSortBy[0].group]
            : !!fieldToSortBy
            ? [fieldToSortBy.sortOrder, fieldToSortBy.sortField]
            : '',
        columns: presetData?.columns || [],
      });

      return;
    }

    // 4: Кількість груп зменшилась на -1
    if (group.length === activeGroupsRef.current.length - 1) {
      const objectValues = group.map((obj) => obj.value);
      const missingIndex = activeGroupsRef.current.findIndex((str) => !objectValues.includes(str));

      // Якщо була видалена перша група
      if (missingIndex === 0) {
        activeGroupsRef.current = group.map((item) => item.value);
        resetPreset({
          ...timeConfig,
          ...filters,
          group: activeGroupsRef.current,
          sort:
            groupsToSortBy.length > 0
              ? [groupsToSortBy[0].sortOrder, groupsToSortBy[0].sortField, groupsToSortBy[0].group]
              : !!fieldToSortBy
              ? [fieldToSortBy.sortOrder, fieldToSortBy.sortField]
              : '',
          columns: presetData?.columns || [],
        });

        await getFirstData(
          {...timeConfig, ...filters, group: objectValues[0]},
          null,
          objectValues,
          groupsToSortBy.length > 0 ? groupsToSortBy[0] : fieldToSortBy
        );
        setFieldToSortBy(null);
        setGroupsToSortBy([]);
        return;
      }

      const newActiveGroups = [...activeGroupsRef.current];
      newActiveGroups.splice(0, missingIndex);

      await Promise.all(
        newActiveGroups.map(async (item) => await deleteTreeByGroup(db.current, item))
      );

      await updateItemByGroup(db.current, activeGroupsRef.current[missingIndex - 1], {
        isOpen: false,
        isExpandable:
          //робимо перевірку якщо це остання група в масиві груп, тоді прибираємо розширення, щоб не було + які не розкриваються
          activeGroupsRef.current[missingIndex - 1] === group[group.length - 1].value
            ? false
            : true,
      });
      const res = await getHierarchicalFlatListSorted(db.current);
      setTableData(res);
      activeGroupsRef.current = group.map((item) => item.value);
      resetPreset({
        ...timeConfig,
        ...filters,
        group: activeGroupsRef.current,
        sort:
          groupsToSortBy.length > 0
            ? [groupsToSortBy[0].sortOrder, groupsToSortBy[0].sortField, groupsToSortBy[0].group]
            : !!fieldToSortBy
            ? [fieldToSortBy.sortOrder, fieldToSortBy.sortField]
            : '',
        columns: presetData?.columns || [],
      });

      return;
    }
  };

  /**
   * Сортування таблиці
   */
  const sort = async (sortOrder, sortField, group) => {
    if (group) {
      // if (groupsToSortBy.length === 0 || groupsToSortBy[0].group === group) {
      //   resetPreset({...presetData, sort: [sortOrder, sortField, group]});
      // }
      resetPreset({...presetData, sort: []});
      // Групове сортування: оновлюємо customOrder для всіх айтемів з вказаною групою
      await sortGroupInDB(db.current, {
        targetGroup: group,
        sortField: sortField,
        sortOrder: sortOrder,
      });
      const findIndexSortedGroups = groupsToSortBy.findIndex((item) => item.group === group);
      if (findIndexSortedGroups !== -1) {
        setGroupsToSortBy((prev) => {
          prev[findIndexSortedGroups].sortOrder = sortOrder;
          return prev;
        });
      } else {
        setGroupsToSortBy((prev) => [...prev, {group, sortOrder, sortField}]);
      }
      setFieldToSortBy(null);
      const res = await getHierarchicalFlatListSorted(db.current);
      setTableData(res);
    } else {
      resetPreset({...presetData, sort: [sortOrder, sortField]});
      // Глобальне сортування: сортуємо всі дані за заданим полем незалежно від груп
      setGroupsToSortBy([]);
      setFieldToSortBy({sortOrder, sortField});
      const res = await getHierarchicalFlatListSortedGlobal(db.current, sortField, sortOrder);
      setTableData(res);
    }
  };

  /**
   * Створює об'єкт фільтру для заданої групи та id
   */
  const createFilter = (group, id) => {
    switch (group) {
      case 'pwa':
        return {app_id: id};
      case 'source':
        return {link_id: id};
      case 'app_type':
        return {app_type: id};
      case 'traffic_type':
        return {traffic_type: id};
      case 'traffic_source':
        return {type: id};
      default:
        return {[`${group}_id`]: id};
    }
  };

  const removeKeysFromObject = (obj, keysToRemove) => {
    const result = {...obj};
    keysToRemove.forEach((key) => {
      delete result[key];
    });
    return result;
  };

  /**
   * Відкриває рядок таблиці для завантаження додаткових даних
   */
  const open = async (itemGroup, itemId, compositeId, childrenGroup) => {
    setCurrentOpening(compositeId);
    const parents = await getAncestorsByCompositeId(db.current, compositeId);

    //Отримуємо всіх предків
    const allAncestors = {
      ...createFilter(itemGroup, itemId),
      ...parents.reduce(
        (acc, item) => ({
          ...acc,
          ...createFilter(
            item.group,
            item.group === 'day' || item.group === 'month' || item.group === 'year'
              ? item.name
              : item.id
          ),
        }),
        {}
      ),
    };

    const obj = {
      ...timeConfig,
      group: childrenGroup,
      ...allAncestors,
      //видалюємо із обєкта фільтрів всіх предків
      ...removeKeysFromObject(activeFiltersRef.current, Object.keys(allAncestors)),
    };

    const req = await store.requestGet(getMethod, {
      params: objectToQueryString(obj),
      preloader: false,
    });

    // Оновлюємо isOpen = true для айтема
    await updateItemByIdAndGroup(db.current, compositeId, {isOpen: true});
    const findSortedGroup = groupsToSortBy.find((item) => item.group === childrenGroup);
    await addFlattenedItemsToGroup(
      db.current,
      req?.rows,
      'group' in req?.filter ? req.filter.group[0] : null,
      compositeId,
      activeGroupsRef.current,
      findSortedGroup || {sortField: 'id', sortOrder: 'desc'}
    );

    let res;
    if (fieldToSortBy !== null) {
      res = await getHierarchicalFlatListSortedGlobal(
        db.current,
        fieldToSortBy?.sortField,
        fieldToSortBy?.sortOrder
      );
    } else {
      res = await getHierarchicalFlatListSorted(db.current);
    }

    setTableData(res);
    setCurrentOpening(null);
  };

  /**
   * Закриває розгорнутий рядок таблиці
   */
  const close = async (compositeId, childrenGroup) => {
    // Оновлюємо isOpen = false для айтема
    await updateItemByIdAndGroup(db.current, compositeId, {isOpen: false});
    await deleteChildrenTreeByIdAndGroup(db.current, compositeId);

    let res;
    if (fieldToSortBy !== null) {
      res = await getHierarchicalFlatListSortedGlobal(
        db.current,
        fieldToSortBy?.sortField,
        fieldToSortBy?.sortOrder
      );
    } else {
      res = await getHierarchicalFlatListSorted(db.current);
    }

    setTableData(res);

    const findIndexChildrenGroup = res.findIndex((item) => item.group === childrenGroup);
    if (findIndexChildrenGroup === -1) {
      const findIndexSortedGroup = groupsToSortBy.findIndex((item) => item.group === childrenGroup);
      const newGroupsToSortBy = structuredClone(groupsToSortBy);
      newGroupsToSortBy.splice(findIndexSortedGroup, 1);
      setGroupsToSortBy(newGroupsToSortBy);
    }
  };

  const contextValue = {
    changeListGroups,
    changeListFilters,
    activeFiltersForFiltersRef: activeFiltersForFiltersRef.current,
    activeGroupsForFiltersRef: activeGroupsForFiltersRef.current,
    filterData,
    link: `${window.location.origin}${replaceTrailingNumberWithChildren(location?.pathname)}`,
    presetId: `preset_${replaceTrailingNumberWithChildren(location?.pathname)}`,
    columnsId: `columns_${replaceTrailingNumberWithChildren(location?.pathname)}`,
    localPresetId: `localPreset_${replaceTrailingNumberWithChildren(location?.pathname)}`,
    columnsSettings,
    setColumnsSettings,
    presets,
    setPresets,
    resetPreset,
    activatePreset,
    timeConfig,
    presetData,
    setPresetData,
    objectToQueryString,
    activePreset,
    setActivePreset,
    defaultGroups,
    defaultFilters,
    hasHiddenGroups,
    setFullMode,
    fullMode,
    CalendarForFullScreen,
    timeInfo,
    resultsCount,
    baseFields,
    disabledByDefault,
    //для пошуку
    tableData,
    setFoundItems,
  };

  return (
    <TableWrapperContext.Provider value={contextValue}>
      <div
        className={classNames(css.container, fullMode && css.container_fullScreen)}
        style={{'--bgFullScreen': theme === 'dark' && !!fullMode ? '#0f1015' : '#F9F9F9'}}
      >
        {children}
        <Table
          locationPathname={replaceTrailingNumberWithChildren(location?.pathname)}
          timeConfig={timeConfig}
          tableData={tableData}
          foundItems={foundItems}
          columnsSettings={columnsSettings}
          presetData={presetData}
          columnsId={`columns_${replaceTrailingNumberWithChildren(location?.pathname)}`}
          loadingData={loadingData}
          activeGroups={activeGroupsRef.current}
          fieldToSortBy={fieldToSortBy}
          groupsToSortBy={groupsToSortBy}
          currentOpening={currentOpening}
          sort={sort}
          open={open}
          close={close}
          setEditItemId={setEditItemId}
          edit={edit}
          fullMode={fullMode}
          baseFields={baseFields}
          branch={branch}
          idForChangeSize={idForChangeSize}
        />
      </div>
    </TableWrapperContext.Provider>
  );
};

export default observer(TableWrapper);
